module.exports = __webpack_public_path__ + "static/media/inspection-report.ad2608a6.svg";